import { Link } from "react-router-dom";
import { C } from "../constants/theme";
import FadeIn from "../components/ui/FadeIn";
import RainbowDivider from "../components/ui/RainbowDivider";
import AnimatedCounter from "../components/ui/AnimatedCounter";

const ISLAMIC_CERT = {
  title: "Finding Hidayah Through Islam",
  org: "Islamic Knowledge",
  color: C.yellow,
  specializations: [
    "Tadabbur-e-Quran — al-Burooj",
    "Arabic Grammar — Qatar",
    "Qur'an Tafseer & Dawah",
    "Prophetic & Islamic Parenting Diploma",
  ],
};

const LUMS_CERT = {
  title: "Certified Trained Teacher",
  org: "From LUMS & UK",
  color: "#8B6BE8",
  specializations: [
    "Classroom Management Specialization",
    "Differentiated Instruction Specialization",
    "Assessment Development Specialization",
    "Dual CPD-Accredited Diploma, UK Teachers Training",
  ],
};

const HARVARD_CERT = {
  title: "Internationally Certified Early Years Educator",
  org: "International Certifications",
  color: C.navy,
  specializations: [
    "Early Years Learning and Education — Harvard",
    "Mitigating Workplace Stress and Promoting Wellbeing: Everyday Science and Strategies for Early Education Leaders — Harvard",
    "Montessori Diploma — PMC",
    "Jolly Phonics UK Certified",
  ],
};

const PARENTING_CERT = {
  title: "Internationally Certified Parenting & Child Behavioral Practitioner",
  org: "Across Turkey & the US",
  color: C.coral,
  specializations: [
    "NLP Certified — Turkey",
    "CBT Certified — US",
    "ABA Certified — US",
    "Emotional Intelligence Certified",
  ],
};

const STATS = [
  { value:"13", suffix:"+", label:"Years in MarTech & Digital Marketing" },
  { value:"6",  suffix:"",  label:"Years Researching & Building This School" },
  { value:"20", suffix:"+", label:"Certifications Across 4 Countries" },
  { value:"2",  suffix:"",  label:"Children Who Inspired It All" },
];

const HT4_PILLARS = [
  { icon:"🎓", label:"Holistic Teaching" },
  { icon:"🤲", label:"Tarbiyah" },
  { icon:"🔄", label:"Transformation" },
  { icon:"📖", label:"Tadabbur" },
];

const About = () => {
  return (
    <div style={{ paddingTop: 72 }}>
      {/* ── Hero ── */}
      <section data-mmn="about-hero" style={{
        background: `linear-gradient(160deg,${C.navy} 0%,#0f2a70 100%)`,
        padding: "100px 6vw 90px", position: "relative", overflow: "hidden",
        minHeight: "52vh", display: "flex", alignItems: "center",
      }}>
        <div style={{ position:"absolute", top:-100, right:-100, width:500, height:500, borderRadius:"50%", background:`${C.yellow}12`, pointerEvents:"none" }}/>
        <div style={{ position:"absolute", bottom:-80, left:-80, width:400, height:400, borderRadius:"50%", background:`${C.coral}10`, pointerEvents:"none" }}/>
        <div style={{ maxWidth:1100, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:`${C.yellow}22`, border:`1px solid ${C.yellow}50`, color:C.yellow, fontFamily:"Nunito", fontWeight:700, fontSize:11, letterSpacing:"0.15em", padding:"6px 16px", borderRadius:100, textTransform:"uppercase", marginBottom:20 }}>
            Meet Our Founder
          </div>
          <h1 style={{ fontFamily:"Fredoka One", fontSize:"clamp(32px,5vw,62px)", color:C.white, lineHeight:1.1, margin:"0 0 14px", maxWidth:680 }}>
            Misbah Ali.
          </h1>
          <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:14, color:C.yellow, letterSpacing:"0.04em", marginBottom:22 }}>
            Founder &amp; Principal, Mini Muslims Nest
          </div>
          <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:"clamp(15px,2vw,19px)", color:"rgba(255,255,255,0.8)", maxWidth:620, lineHeight:1.82, margin:0 }}>
            The mother who built this. Vision, struggles, and quiet dedication — years in the making, long before the first circle time.
          </p>
        </div>
      </section>

      {/* ── Stat Bar ── */}
      <section data-mmn="about-stats" style={{ background:C.navy, padding:"48px 6vw" }}>
        <div style={{ maxWidth:1000, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:24, textAlign:"center" }}>
          {STATS.map(({ value, suffix, label }, i) => (
            <FadeIn key={label} delay={i * 0.08}>
              <div style={{ fontFamily:"Fredoka One", fontSize:"clamp(30px,4vw,44px)", color:C.yellow }}>
                <AnimatedCounter value={value} suffix={suffix} />
              </div>
              <div style={{ fontFamily:"Nunito", fontWeight:600, fontSize:12.5, color:"rgba(255,255,255,0.75)", marginTop:6, letterSpacing:"0.02em", lineHeight:1.4 }}>{label}</div>
            </FadeIn>
          ))}
        </div>
      </section>

      {/* ── Meet the Founder ── */}
      <section data-mmn="about-founder" style={{ background:C.warmGray, padding:"100px 6vw" }}>
        <div style={{ maxWidth:820, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:44 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Six Years, Not Six Months</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,42px)", color:C.navy, margin:"0 0 16px", lineHeight:1.2 }}>From Boardroom to Classroom.</h2>
              <RainbowDivider />
            </div>
          </FadeIn>

          <FadeIn delay={0.1}>
            <div style={{ fontFamily:"Nunito", fontSize:15, color:C.text, lineHeight:2, marginBottom:20 }}>
              <p style={{ marginBottom:18 }}>Our founder, <b style={{ color:C.navy }}>Misbah Ali</b>, left her role as a Worldwide Manager at a multi-million-dollar company because her daughter needed her — and no one was offering a remote or hybrid way to stay close. She held on to one belief: rizq comes from Allah, not a job. A family business followed soon after, and with it came something she hadn't had in years — time. Today she runs that business as a <b style={{ color:C.navy }}>mompreneur</b>, managing home and work side by side, and spends much of that time encouraging other women to build the same for themselves. It also gave her time to fall in love with homeschooling, and to study early childhood development, child behaviour, class management, and emotional intelligence at Yale, Harvard, LUMS, and CPD-accredited bodies across the UK and Europe.</p>
              <p style={{ marginBottom:0 }}>That learning was for her own daughter first, then her son — after she kept finding the same thing everywhere she looked for a positive, Islamic socialisation space: activities rushed through by teachers with one eye on the clock. So in 2021, she stopped looking for a school like that, and started building the one she couldn't find instead — deliberately small, deliberately a micro school, so no child would ever be a face in a crowd.</p>
            </div>
          </FadeIn>

          <FadeIn delay={0.15}>
            <div style={{ margin:"36px 0", position:"relative", paddingLeft:26 }}>
              <div style={{ position:"absolute", left:7, top:4, bottom:4, width:3, background:`linear-gradient(${C.mint},${C.coral})`, borderRadius:2 }}/>
              {[
                { yr:"2021", body:"The research begins — curriculums studied, ECE literature read, frameworks understood — before a single class was ever taught." },
                { yr:"2024", body:"The Afterschool Socialisation Club opens, ages 2.5–12. Every circle time, every Friday halqa, every day block is tested here first, with real children." },
                { yr:"Today", body:"Mothers travel from as far as Sheikhupura and Askari 11 to reach the club. Every child known by name — by their choices, by what makes them who they are." },
                { yr:"January 2027", body:"Everything the club taught becomes its own dedicated Preschool, ages 4–7 — onsite, online, or hybrid. Not a rushed launch. A culmination." },
              ].map(({ yr, body }, i, arr) => (
                <div key={yr} style={{ marginBottom: i === arr.length-1 ? 0 : 20, position:"relative" }}>
                  <div style={{ position:"absolute", left:-26, top:2, width:16, height:16, borderRadius:"50%", background:C.white, border:`3px solid ${C.mint}` }}/>
                  <div style={{ fontFamily:"Fredoka One", fontSize:16, color:C.coral, marginBottom:2 }}>{yr}</div>
                  <p style={{ fontFamily:"Nunito", fontSize:14, color:C.text, lineHeight:1.7, margin:0 }}>{body}</p>
                </div>
              ))}
            </div>
          </FadeIn>

          <FadeIn delay={0.18}>
            <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:15, color:C.muted, lineHeight:1.8, textAlign:"center", maxWidth:600, margin:"0 auto 30px" }}>
              None of this was quick, and none of it was an accident. Years of deliberate study sit behind every circle time she leads.
            </p>
          </FadeIn>

        </div>
      </section>

      {/* ── Experience (narrative) ── */}
      <section data-mmn="about-experience" style={{ background:C.white, padding:"100px 6vw" }}>
        <div style={{ maxWidth:820, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:36 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Experience</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,42px)", color:C.navy, margin:"0 0 16px", lineHeight:1.2 }}>Recognised Beyond the Classroom.</h2>
              <RainbowDivider />
            </div>
          </FadeIn>
          <FadeIn delay={0.1}>
            <div style={{ fontFamily:"Nunito", fontSize:15, color:C.text, lineHeight:2 }}>
              <p style={{ marginBottom:18 }}>
                Beyond the classroom, Misbah brings over <b style={{ color:C.navy }}>13 years of MarTech and MarCom expertise</b> to everything she builds — recognised as an award-winning certified digital marketer, and named <b style={{ color:C.navy }}>Community Organizer for Google</b>. She has organised international tradeshows and conferences, and worked directly with the Government of Pakistan and foreign investors on the country's startup ecosystem — work that saw her nominated in the P@SHA CEC Elections.
              </p>
              <p style={{ margin:0 }}>
                She has taken the stage at <b style={{ color:C.navy }}>WordCamp Lahore</b> and the <b style={{ color:C.navy }}>LIFT Conference</b>, and been invited back to speak at her alma mater, <b style={{ color:C.navy }}>FAST NUCES Islamabad</b> — the same institution where she once walked in as a BS (Hons) Computer Science student, and later returned to share the same stage as her own teachers, this time as a speaker guiding her fellow Fastians. That same boardroom discipline — research, structure, follow-through — is what now runs quietly behind every circle time at Mini Muslims Nest.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── Certifications (representation) ── */}
      <section data-mmn="about-credentials" style={{ background:C.cream, padding:"100px 6vw" }}>
        <div style={{ maxWidth:960, margin:"0 auto" }}>
          <FadeIn>
            <div style={{ textAlign:"center", marginBottom:56 }}>
              <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.coral, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Certifications</div>
              <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,42px)", color:C.navy, margin:"0 0 16px", lineHeight:1.2 }}>Years of Deliberate Study.</h2>
              <RainbowDivider />
              <p style={{ fontFamily:"Lora", fontStyle:"italic", fontSize:15, color:C.muted, lineHeight:1.8, maxWidth:560, margin:"18px auto 0" }}>
                From marketing boardrooms to Montessori certification — a decade of building, unlearning, and studying, in that order.
              </p>
            </div>
          </FadeIn>

          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(320px,1fr))", gap:24 }}>
            {[ISLAMIC_CERT, HARVARD_CERT, LUMS_CERT, PARENTING_CERT].map((cert, ci) => (
              <FadeIn key={cert.title} delay={ci * 0.06}>
                <div style={{
                  height:"100%", background:`linear-gradient(135deg, ${cert.color}15, ${cert.color}05)`,
                  border:`2px solid ${cert.color}35`, borderRadius:20, padding:"28px 26px",
                  boxSizing:"border-box",
                }}>
                  <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:20 }}>
                    <div style={{
                      width:56, height:56, borderRadius:"50%", flexShrink:0,
                      background:`linear-gradient(160deg, ${cert.color}, ${cert.color}cc)`,
                      display:"flex", alignItems:"center", justifyContent:"center", fontSize:25,
                      border:`3px solid ${C.white}`, boxShadow:`0 8px 18px ${cert.color}45`,
                    }}>🏅</div>
                    <div>
                      <div style={{ fontFamily:"Fredoka One", fontSize:17, color:C.navy, lineHeight:1.3 }}>{cert.title}</div>
                      <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:cert.color, textTransform:"uppercase", letterSpacing:"0.04em" }}>{cert.org}</div>
                    </div>
                  </div>
                  <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:11, color:C.muted, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:12 }}>
                    {cert.specializations.length} {cert.specializations.length === 1 ? "Certification" : "Specializations"}
                  </div>
                  <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                    {cert.specializations.map(s => (
                      <div key={s} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                        <div style={{ width:8, height:8, borderRadius:"50%", background:cert.color, flexShrink:0, marginTop:6 }}/>
                        <span style={{ fontFamily:"Nunito", fontSize:13.5, color:C.text, lineHeight:1.6 }}>{s}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.35}>
            <div style={{ marginTop:48, background:C.navy, borderRadius:20, padding:"32px 30px" }}>
              <div style={{ fontFamily:"Fredoka One", fontSize:18, color:C.yellow, marginBottom:8 }}>HT4 — the framework behind our teachers and mothers</div>
              <p style={{ fontFamily:"Nunito", fontSize:13.5, color:"rgba(255,255,255,0.78)", lineHeight:1.8, margin:"0 0 22px" }}>
                HT4 is a four-pillar system Misbah built herself, weaving Bloom's Taxonomy, Montessori, Waldorf, Reggio Emilia, and child psychology — ZPD, CBT, ABA, NLP, Polyvagal Theory — together with Islamic tarbiyah. It isn't only for teachers — before a teacher leads a single circle time here, they train through it, and mothers go through their own HT4 modules too, built specifically around their journey rather than a classroom.
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12 }}>
                {HT4_PILLARS.map(p => (
                  <div key={p.label} style={{
                    background:"rgba(255,255,255,0.07)", border:"1px solid rgba(255,255,255,0.16)",
                    borderRadius:14, padding:"18px 12px", textAlign:"center",
                  }}>
                    <div style={{ fontSize:24, marginBottom:8 }}>{p.icon}</div>
                    <div style={{ fontFamily:"Nunito", fontWeight:700, fontSize:12, color:C.white }}>{p.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── Also Explore ── */}
      <section style={{ background:C.warmGray, padding:"36px 6vw" }}>
        <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center", display:"flex", gap:20, justifyContent:"center", flexWrap:"wrap" }}>
          <Link to="/about/story" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Our Story →</Link>
          <Link to="/about/staff" style={{ fontFamily:"Nunito", fontWeight:700, fontSize:13.5, color:C.navy, textDecoration:"none" }}>Meet Our Staff →</Link>        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background:C.cream, padding:"80px 6vw" }}>
        <div style={{ maxWidth:640, margin:"0 auto", textAlign:"center" }}>
          <FadeIn>
            <h2 style={{ fontFamily:"Fredoka One", fontSize:"clamp(24px,3.5vw,38px)", color:C.navy, margin:"0 0 14px" }}>Ready to Learn More?</h2>
            <p style={{ fontFamily:"Nunito", fontSize:15, color:C.muted, lineHeight:1.75, marginBottom:32 }}>Come see the school. Meet the team. Feel the environment.</p>
            <div style={{ display:"flex", gap:14, justifyContent:"center", flexWrap:"wrap" }}>
              <Link to="/admissions#interest-form" style={{ background:C.navy, color:C.white, textDecoration:"none", fontFamily:"Nunito", fontWeight:800, fontSize:15, padding:"16px 36px", borderRadius:100, boxShadow:"0 6px 24px rgba(27,63,139,0.28)", display:"inline-block" }}>Enroll Your Child</Link>
              <Link to="/contact" style={{ background:"transparent", color:C.navy, textDecoration:"none", fontFamily:"Nunito", fontWeight:700, fontSize:15, padding:"16px 36px", borderRadius:100, border:`2.5px solid ${C.navy}`, display:"inline-block" }}>Get in Touch</Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default About;
